// @flow

import React from 'react';
import Bugsnag from 'bugsnag-js';
import createPlugin from 'bugsnag-react';

const PROTOCOL_IGNORE_LIST = [
  'chrome-extension:',
  'moz-extension:',
  'safari-extension:'
];

const bugsnag = Bugsnag({
  ...window._bugsnag,
  beforeSend(report) {
    if (report.stackTrace.some(({ file }) => {
      let protocol;

      try {
        protocol = new URL(file).protocol;
      } catch (error) {
        // Don't block "Global code" or other non-URL stuff
        return false;
      }

      return PROTOCOL_IGNORE_LIST.indexOf(protocol) !== -1;
    })) {
      report.updateMetaData('testing', { hasIgnoredProtocol: true });
      // TODO: report.ignore();
    }
  }
});

export default bugsnag;

export const ErrorBoundary = bugsnag.use(createPlugin(React));
